import { WebView } from '@zenbusiness/application-commons-webview';
import Empty from '@zenbusiness/zui/Empty';
import Text from '@zenbusiness/zui/Text';

import * as Styled from './AppFooter.style';
import { DisclosureText } from './DisclosureText';

const EMOJI_LIST = ['🐐', '🌮', '❤️'];
const madeWithEmoji = EMOJI_LIST[Math.floor(Math.random() * EMOJI_LIST.length)];
const releaseYear = new Date().getFullYear();

function AppFooter() {
  if (WebView.isWebView) {
    return <Empty />;
  }

  return (
    <Styled.Root>
      <DisclosureText />

      <Text
        color="tertiary"
        size="sm"
      >
        {`Made with ${madeWithEmoji} remotely by ZenBusiness INC © ${releaseYear} All Rights Reserved.`}
      </Text>
    </Styled.Root>
  );
}

export default AppFooter;
